// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1md1J","footer":"ModalCreateQualiphyProcedure_footer__3oAqi","additionData":"ModalCreateQualiphyProcedure_additionData__3sk1-"};